<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('certificates.title')"></page-header-title>

      <v-spacer></v-spacer>

      <v-form ref="form" @submit.prevent="filter" class="mt-8 d-none d-sm-flex">
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                :label="$t('global.search')"
                v-model="search_params.any"
                @keydown="checkKeyPress"
                autocomplete="new-password"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <router-link :to="BACKEND_URL + '/certificates/create'" v-if="$can('certificate-create')">
        <action-button type="new" />
      </router-link>
    </v-app-bar>
    <v-card>
      <v-card-text>
        <v-flex md12>
          <v-data-table
            :headers="headers"
            :items="certificates"
            :items-per-page="certificates.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :click:row="rowClicked"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            :must-sort="true"
          >
            <template v-slot:item="{ item, index }">
              <tr
                v-for="(row, idx) in item.row_titles"
                :key="item.id + '-' + idx"
                :class="item.row_titles && item.row_titles.length > 1 ? 'grouped ' + (index % 2 == 1 ? 'odd' : 'even') : ''"
              >
                <td>{{ item.row_titles[idx] }}</td>
                <td>
                  <router-link
                    :to="{ path: BACKEND_URL + '/users/account/edit/' + item.user_id, props: { id: item.user_id } }"
                    v-if="$can('user-access')"
                  >
                    {{ item.user ? item.user.first_name + " " + item.user.last_name : "" }}
                  </router-link>
                </td>
                <td>{{ item.issued_date ? moment.utc(item.issued_date).format(DATE_FORMAT) : null }}</td>
                <td>{{ item.issued_by }}</td>
                <td>{{ item.company_name }}</td>
                <td class="text-end">
                  <router-link
                    :to="{ path: BACKEND_URL + '/certificates/edit/' + item.id, props: { id: item.id } }"
                    v-if="$can('certificate-edit')"
                  >
                    <action-button type="edit" :icon_only="true" small />
                  </router-link>

                  <action-button
                    type="delete"
                    :icon_only="true"
                    @click="del(item.id)"
                    v-if="$can('certificate-delete')"
                    :disabled="Boolean(item.tenant_certificate_id)"
                    small
                  />
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "CertificatesList",

  data() {
    return {
      url: "",
      certificates: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        page: this.$getLocalStorage("__page_Certificate_List", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["title"],
        sortDesc: [false]
      },
      search_params: {
        any: "",
        title: ""
      }
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("certificates.title"), value: "title" },
          { text: this.$t("certificates.user_id"), value: "user_id" },
          { text: this.$t("certificates.issued_date"), value: "issued_date" },
          { text: this.$t("certificates.issued_by"), value: "issued_by" },
          { text: this.$t("certificates.company"), value: "company_name" },
          { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end", sortable: false }
        ]
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (
            _.has(newVal, "sortBy") &&
            _.has(newVal, "sortDesc") &&
            _.has(oldVal, "sortBy") &&
            _.has(oldVal, "sortDesc") &&
            (!_.isEqual(newVal.sortBy, oldVal.sortBy) || !_.isEqual(newVal.sortDesc, oldVal.sortDesc))
          ) {
            let obj = {
              sortBy: this.pagination.sortBy,
              sortDesc: this.pagination.sortDesc
            }
            localStorage.setItem("__sort_Certificate_List", JSON.stringify(obj))
          }

          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_Certificate_List", newVal.page)
          }

          this.refresh = true
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "certificates"
  },

  methods: {
    list() {
      this.show_loading = true

      let localFilter = localStorage.getItem("__filter_Certificate_List")
      if (localFilter !== null) {
        localFilter = JSON.parse(localFilter)
        this.search_params = localFilter
      }

      let localSort = localStorage.getItem("__sort_Certificate_List")
      if (localSort !== null) {
        localSort = JSON.parse(localSort)
        this.pagination.sortBy = localSort.sortBy
        this.pagination.sortDesc = localSort.sortDesc
      }

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios.get(this.url + "?" + query).then((res) => {
        this.certificates = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    rowClicked() {
      alert(1)
    },

    filter(target) {
      this.pagination.page = 1
      this.refresh = true
      localStorage.setItem("__filter_Certificate_List", JSON.stringify(this.search_params))
    },

    reset() {
      this.$refs.form.reset()
      this.pagination.page = 1
      this.refresh = true
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "certificate/" + id)
            .then((res) => {
              vm.refresh = true
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    }
  }
}
</script>

<style>
/*tr.grouped.even td:first-child {
    border-left: 5px solid rgba(00,107,84,.8) !important;
}
tr.grouped.odd td:first-child {
    border-left: 5px solid rgba(39,155,180,.8) !important;
}*/
</style>
